export default __webpack_public_path__ + "static/media/oversight3.7779ab2a.png";